export const PublicRoutes ={
    AUTH: '/' ,
    LOGIN: 'login' 
}
export const RoutesPrivate={
    DASHBOARD: '/tomar-foto',
    CAMBIARPASS:'/Cambiar-pass'
}